export const POST_PURGE_ACCOUNTS = (examLevel: string) => `/admin/purge-accounts/${examLevel}`;

export const GET_ORGANIZATIONS = '/admin/organizations';

export const GET_USER_ACCOUNT_STATUS = '/admin/account-status';
